var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMinYMid meet",
    viewBox: "0 0 48 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 48,
    height: 30,
    rx: 3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-1-Copy-68"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#C5C5C8",
    strokeWidth: 1,
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 29,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4516757,10.1688 L18.8865,19.8564 L21.3883012,19.8564 L22.953,10.1688 L20.4516757,10.1688 L20.4516757,10.1688 Z M30.0987853,16.6908293 C30.1078463,15.5868186 29.4411516,14.7498689 27.9976001,14.0588488 C27.1234574,13.6096142 26.5869541,13.312032 26.5931537,12.8575516 C26.5941075,12.4545758 27.0466778,12.0234632 28.0262136,12.0234632 C28.8445599,12.0105871 29.4368595,12.1989604 29.8984908,12.3959178 L30.1231068,12.5065573 L30.4617,10.406791 C29.9671632,10.212218 29.1893527,10 28.2203086,10 C25.7471477,10 24.0064926,11.314798 23.991709,13.1971005 C23.9759716,14.5896323 25.2340121,15.3664934 26.1825499,15.829081 C27.1573167,16.303591 27.4849414,16.6073728 27.4811263,17.031332 C27.4739729,17.6803853 26.7028389,17.9774906 25.983686,17.9774906 C24.9822132,17.9774906 24.450002,17.831084 23.6273637,17.469598 L23.3059386,17.3150842 L22.9559,19.4835233 C23.5391387,19.7534456 24.6207293,19.9876007 25.7428557,20 C28.3710064,20 30.0787559,18.7014164 30.0987853,16.6908293 L30.0987853,16.6908293 Z M33.634524,10.9814874 L29.9195,19.8598 L32.546723,19.8598 C32.546723,19.8598 32.975453,18.6656605 33.0727399,18.4033695 C33.3593547,18.4033695 35.9121818,18.4081384 36.2765308,18.4081384 C36.3514035,18.7462554 36.5812677,19.8598 36.5812677,19.8598 L38.9028,19.8598 L36.8783742,10.1784 L34.9455126,10.1784 C34.3455767,10.1784 33.8968171,10.3500814 33.634524,10.9814874 L33.634524,10.9814874 Z M35.2903433,13.6253948 C35.2903433,13.6253948 35.7705817,15.9373759 35.8693,16.4219 L33.7924,16.4219 C33.9998515,15.8648881 34.7891212,13.7140971 34.7891212,13.7140971 C34.7743373,13.7393724 34.9951421,13.1527931 35.1215206,12.7894 L35.2903433,13.6253948 L35.2903433,13.6253948 Z M15.4996485,19.8464693 L19.4388,10.1769765 L16.7882184,10.1769765 L14.3398402,16.7814747 L14.077548,15.4390195 L13.2010153,10.9876955 C13.0498396,10.3739335 12.6101426,10.1917602 12.0669593,10.1703 L8.03338264,10.1703 L8,10.3710722 C8.98144961,10.6219182 9.85893615,10.9838803 10.6276907,11.4335909 L12.8524052,19.8479 L15.4996485,19.8464693 L15.4996485,19.8464693 Z",
    id: "Fill-1-Copy-14",
    fill: "#152F94"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.01899085b16caf2684552cbd9b63525c.svg";
export { ForwardRef as ReactComponent };